import { useEffect, useState } from 'react';

export default function ImageLightbox({ open, title, url, onClose, onDownload }) {
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open || !url) return null;

  const handleDownload = async () => {
    if (!onDownload || downloading) return;
    setDownloading(true);
    try {
      await onDownload();
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div
      className="admin-lightbox-overlay"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="admin-lightbox-content"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label={title || 'Vista ampliada'}
      >
        <header className="admin-lightbox-header">
          <span className="admin-lightbox-title">{title || 'Vista ampliada'}</span>
          <div className="admin-lightbox-actions">
            {onDownload && (
              <button
                type="button"
                className="admin-lightbox-btn"
                onClick={handleDownload}
                disabled={downloading}
                aria-label="Descargar imagen"
              >
                <span className="material-symbols-outlined">download</span>
                <span className="admin-lightbox-btn-label">
                  {downloading ? 'Descargando…' : 'Descargar'}
                </span>
              </button>
            )}
            <button
              type="button"
              className="admin-lightbox-btn"
              onClick={onClose}
              aria-label="Cerrar"
            >
              <span className="material-symbols-outlined">close</span>
            </button>
          </div>
        </header>
        <div className="admin-lightbox-image-wrap">
          <img src={url} alt={title || 'Imagen ampliada'} className="admin-lightbox-image" />
        </div>
      </div>
    </div>
  );
}
